import { Store } from "@ngrx/store";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Injectable, OnInit, Injector } from "@angular/core";
import { Observable, NEVER, from, throwError, of } from "rxjs";
import { catchError } from "rxjs/operators";

import { GeneralService } from "../services/general.service";
import { AppState } from "../store/app.state";
import { OrganizationService } from "../services/organizationservice";
import { DEMODATALIMITING } from "../data/demoData";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "./auth.service";
import { Router } from "@angular/router";

declare var stopPageTransition: any;

@Injectable()
export class AuthcrudInterceptorService implements HttpInterceptor, OnInit {
  apiKey: string;
  orgId;
  origin = window.location.origin;
  constructor(private genSer: GeneralService, store: Store<AppState>,
    private organisation_service: OrganizationService, private toast: ToastrService,
    private injector: Injector) {
    store.select("userInfo").subscribe((info) => {
      if (info && info.user && info.organization) {
        this.orgId = info.organization.id;
        this.apiKey = info.apiKey;
      }
    });
  }

  ngOnInit() { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes("notchcx") || req.url.includes("localhost")) {
      // Append to all Request Begins!
      if (this.apiKey != undefined) {
        req = req.clone({
          setHeaders: {
            orgId: `orgId ${this.orgId}`,
            Authorization: `Bearer ${this.apiKey}`,
          },
        });
      }
      // Append to all Request Ends!

      if (this.origin === 'https://demo.notchcx.io' || this.origin === 'http://localhost:1100') {
        const { method, url } = req
        const modules = DEMODATALIMITING;
        if (method === 'POST') {
          const activeModule = modules.find(res => res.modulePath === url)
          if (activeModule) {
            return from(this.demoDataStatus(req, next, activeModule.name)).pipe(
              catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                  this.handle401Error();
                }
                return throwError(error);
              })
            );
          }
        }
        return next.handle(req).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.handle401Error();
            }
            return throwError(error);
          })
        );
      }
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.handle401Error();
            return of(null);
          }
          return throwError(error);
        })
      );
    }
  }
  // Observer closer

  private handle401Error() {
    try {
      const authService = this.injector.get(AuthService);
      authService.logout();
    } catch (e) {
      localStorage.clear();
      sessionStorage.clear();
    }
    try {
      const router = this.injector.get(Router);
      router.navigate(["/login"]);
    } catch (e) {
      window.location.href = "/login";
    }
  }

  async demoDataStatus(req: HttpRequest<any>, next: HttpHandler, searchModule) {
    const dataCounts = await this.organisation_service.getOrganizationDemoDBStatus(this.orgId);
    const status = dataCounts[searchModule] < 5;
    !status ? this.toast.error(`Sorry!!! You cannot create more than 5 ${searchModule.toUpperCase()}(S) for Demo Organization`) : 0;
    return status ? next.handle(req).toPromise() : NEVER.toPromise();
  }
}
